import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const postCollection = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.DISTRIBUTE.POST_COLLECTION,
    data
  );
};

export default postCollection;
